import * as AppConstants from '../constants/AppConstants'

const initialState = {
  data: null,
  isLoading: false,
  error: null
}

export default function UserState(state = initialState, { type, payload, error }) {
  switch (type) {
    case AppConstants.USER_LOGGING_IN:
      return { ...initialState, isLoading: true }
    case AppConstants.USER_LOGGED_IN:
      return { ...initialState, data: payload }
    case AppConstants.USER_LOGGED_OUT:
      return initialState
    case AppConstants.USER_LOGIN_ERROR:
    case AppConstants.USER_LOGOUT_ERROR:
      return { ...initialState, error: error }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/UserReducer.js